import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const deleteMessage = async (questionNoteId) => {
  const data = await request.delete(
    `/Question/note`,
    { questionNoteId },
    'Не удалось удалить комментарий',
    'Error'
  );

  return data;
};

const useDeleteMsgMutation = (options) => {
  return useMutation(
    ({ questionNoteId }) => deleteMessage(questionNoteId),
    options
  );
};

export default useDeleteMsgMutation;
